import React, { Component } from 'react';
import Notificacao from '../../components/Notificacao';
import { getLoggedInUser } from "../../helpers/authUtils";
import IconAdd from '../../assets/svg/add-plus.svg';
import PreLoaderWidget from '../../components/Loader';
import { FilaProcedimentoEnum, PermissaoGeral } from '../../helpers/enums';
import SelectIcon from '../../gb-components/SelectIcon';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import DropDownPacientesAlgolia from '../../components/DropDownPacientesAlgolia';
import moment from 'moment';
import LoadingFullScreen from '../../components/LoadingFullScreen';
import {
    getFormaOrganizacaoProc,
    getGruposProc,
    getProcedimentos,
    getSubGruposProc,
    saveFila,
    saveLogFila,
    updateFila
} from '../../Libs/filaProcedimentos';
import Select from 'react-select';
import InputFileIcon from '../../gb-components/InputFileIcon';
import IconFile from '../../assets/svg/ic-actions-add-file.svg';
import Compress from 'compress.js';
import { onlyNumbers } from '../../helpers/utils';
import {
    firebaseStorage
} from '../../helpers/firebase-config';

const dropDownStyles = {
    container: base => ({
        ...base,
        flex: 1,
        padding: 1
    }),
    control: base => ({
        ...base,
        padding: 10
    })
}

export default class CadastroPacienteFila extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: getLoggedInUser(),
            notifition: false,
            loading: false,
            saving: false,
            gruposProcedimentos: [],
            subProcedimentos: null,
            formaOrganizacao: null,
            procedimentosList: null,
            procedimentosListShow: null,
            grupoSelect: "",
            subSelect: "",
            formaOrganizacaoSelect: "",
            procedimento: null,
            foraMunicipio: true,
            paciente: null,
            arquivo: null,
        };

        this.getGrupos = this.getGrupos.bind(this);
        this.onChangeArquivo = this.onChangeArquivo.bind(this);
    }

    async componentDidMount() {
        this.setState({ loading: true })
        await this.getGrupos()
        // console.log(this.props)
        const item = this.props.item
        if (item) {
            let cod = item.procedimento.codigo.split('.')
            const grupo = cod[0];
            const subGrupo = cod[1];
            const formaOrganizacao = cod[2];

            await this.getSubGrupos(grupo)
            await this.getFormaOrganizacao(grupo, subGrupo)
            await this.getProcedimentosFn(grupo, subGrupo, formaOrganizacao)
            this.setState({
                grupoSelect: grupo,
                subSelect: subGrupo,
                formaOrganizacaoSelect: formaOrganizacao,
                procedimento: {
                    value: item.procedimento,
                    label: `${item.procedimento.codigo} - ${item.procedimento.descricao}`
                },
                paciente: {
                    value: item.paciente,
                    label: item.paciente.paciente.nome + " | " + item.paciente.paciente.cpf + " | " + (item.paciente.paciente.cns || '')
                },
                foraMunicipio: item.fora_municipio,
                arquivo: item.arquivo,
            })
        }
        this.setState({ loading: false })
    }

    async getGrupos() {
        const grupos = await getGruposProc()
        const gruposProcedimentos = grupos.map(g => {
            return { id: g.codigo, nome: `${g.codigo} - ${g.descricao}` }
        })
        this.setState({ gruposProcedimentos })
    }

    async getSubGrupos(grupoId) {
        const subGrupos = await getSubGruposProc(grupoId)
        const subProcedimentos = subGrupos.map(g => {
            return { id: g.codigo, nome: `${g.codigo} - ${g.descricao}` }
        })
        this.setState({
            subProcedimentos,
            saving: false,
        })
    }

    async getFormaOrganizacao(grupoId, subGrupoId) {
        const formaOrganizacaoDb = await getFormaOrganizacaoProc(grupoId, subGrupoId)
        const formaOrganizacao = formaOrganizacaoDb.map(g => {
            return { id: g.codigo, nome: `${g.codigo} - ${g.descricao}` }
        })
        this.setState({
            formaOrganizacao,
            saving: false,
        })
    }

    async getProcedimentosFn(grupo, subgrupo, formaOrganizacao) {
        const procedimentosDb = await getProcedimentos(
            grupo,
            subgrupo,
            formaOrganizacao
        )
        const procedimentosList = procedimentosDb.map(g => {
            return {
                value: g,
                label: `${g.codigo} - ${g.descricao}`
            }
        })
        this.setState({
            procedimentosList,
            procedimentosListShow: procedimentosList,
            saving: false,
        })
    }

    changeGrupo(grupo) {
        this.setState({
            grupoSelect: grupo,
            subProcedimentos: null,
            formaOrganizacao: null,
            procedimentosList: null,
            procedimentosListShow: null,
            subSelect: "",
            formaOrganizacaoSelect: "",
            procedimento: null,
            saving: true
        })
        this.getSubGrupos(grupo)
    }

    changeSubGrupo(subGrupo) {
        this.setState({
            subSelect: subGrupo,
            formaOrganizacao: null,
            procedimentosList: null,
            procedimentosListShow: null,
            formaOrganizacaoSelect: "",
            procedimento: null,
            saving: true
        })

        this.getFormaOrganizacao(this.state.grupoSelect, subGrupo)
    }

    changeFormaOrganizacao(formaOrganizacao) {
        this.setState({
            formaOrganizacaoSelect: formaOrganizacao,
            procedimentosList: null,
            procedimentosListShow: null,
            procedimento: null,
            saving: true
        })

        this.getProcedimentosFn(
            this.state.grupoSelect,
            this.state.subSelect,
            formaOrganizacao
        )
    }

    filtrarProcedimento(e) {
        let lst = this.state.procedimentosList.filter(x =>
        (e && e != '' && x.label ? (x.label.toLowerCase().indexOf(e.toLowerCase()) >= 0) ||
            (x.value.descricao.toLowerCase().indexOf(e.toLowerCase())) >= 0 : true)
        )
        this.setState({ procedimentosListShow: lst })
    }

    onChangeArquivo(event) {
        this.setState({ arquivo: event[0] })
    }

    async uploadImg(filePath, finalFile, metadata) {
        return new Promise((resolve, reject) => {
            const storageRef = firebaseStorage.ref();
            const uploadTask = storageRef.child(filePath).put(finalFile, metadata);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log("Upload is " + progress + "% done");
                },
                (error) => {
                    console.log(error);
                    reject(error);
                },
                async () => {
                    const imgURL = await uploadTask.snapshot.ref.getDownloadURL();
                    console.log("uploaded image: " + imgURL);
                    resolve(imgURL);
                }
            );
        });
    };


    _setCadastro = async () => {
        this.setState({ saving: true });
        const {
            paciente,
            procedimento,
            arquivo
        } = this.state;

        console.log(paciente.value.id)
        console.log(paciente.value.id)

        if (!paciente) {
            this.setState({
                notifition: true,
                msg: "Informe um paciente",
                nameclass: 'alert-danger',
                loading: false
            });
            return;
        }

        if (!procedimento) {
            this.setState({
                notifition: true,
                msg: "Informe um procedimento",
                nameclass: 'alert-danger',
                loading: false
            });
            return;
        }

        let url = ''
        if (arquivo) {
            let finalFile = arquivo
            const type = arquivo.type
            if (type !== "application/pdf") {
                const compress = new Compress()
                const compressedFile = await compress.compress(
                    [arquivo], {
                    size: 1,
                    quality: 0.75,
                })
                const img1 = compressedFile[0]
                const base64str = img1.data
                finalFile = Compress.convertBase64ToFile(base64str, type)
            }

            const fileExt = arquivo.name.split('.').pop()

            const pacId = onlyNumbers(paciente.value.id.toString())
            const procId = onlyNumbers(procedimento.value.id.toString())
            const filePath = `fila_procedimento/${pacId}_${procId}_${new Date().getTime()}.${fileExt}`

            const metadata = {
                contentType: type
            };
            // const task = await firebaseStorage.ref().child(filePath).put(finalFile, metadata);
            // url = task.snapshot.ref.getDownloadURL()
            url = await this.uploadImg(filePath, finalFile, metadata)
        }

        let data = {
            paciente: paciente.value,
            paciente_id: paciente.value.id,
            procedimento: procedimento.value,
            procedimento_id: procedimento.value.id,
            status: FilaProcedimentoEnum.Aguardando,
            viagemId: null,
            data_agendamento: null,
            hora_agendamento: null,
            secretaria_id: this.props.secretariaSelecionada,
            fora_municipio: this.state.foraMunicipio,
            confirm_wp_message_id: null,
            confirmed: null,
            arquivo: url
        }

        // console.log(data)
        // console.log(this.props.item)

        try {
            if (this.props.item) {
                data.updated_at = moment().format('YYYY-MM-DD HH:mm:ss')
                data.user_update = this.state.user.ref
                await updateFila(this.props.item.id, data)
                await saveLogFila(this.props.item.id, data)
            } else {
                data.created_at = moment().format('YYYY-MM-DD HH:mm:ss')
                data.data_fila = moment().format('YYYY-MM-DD HH:mm:ss') // utilizado para pegar a sequencia
                data.user_create = this.state.user.ref
                const savedFila = await saveFila(data)
                await saveLogFila(savedFila.id, data)
            }
            this.setState({ saving: false })
            if (this.props.closeModal) {
                this.props.closeModal();
            }
        } catch (error) {
            console.log(error)
            this.setState({
                notifition: true,
                msg: "Algo deu errado, tente novamente ou entre em contato conosco",
                nameclass: 'alert-danger',
                saving: false
            });
        }
    };

    render() {
        if (getLoggedInUser().permissao.toString() !== PermissaoGeral.Paciente) {
            return (
                <React.Fragment>
                    {this.state.saving && <LoadingFullScreen></LoadingFullScreen>}

                    {this.state.loading ? (<div className="text-center"><PreLoaderWidget /> aguarde...</div>) : (

                        <div className="gb-form">

                            <div className="title">
                                {this.props.item <= 0 ? (
                                    <>
                                        <img src={IconAdd} /> Adicionar Paciente Procedimento
                                    </>
                                ) : (
                                    <>
                                        Editar Paciente Procedimento
                                    </>
                                )}
                            </div>

                            {this.state.notifition ? (
                                <div className="pl-2 pr-2 m-1">
                                    <Notificacao
                                        msg={this.state.msg}
                                        nameclass={this.state.nameclass}
                                    />
                                </div>
                            ) : null}

                            <div className="row">
                                <div className="col-12 ">
                                    <DropDownPacientesAlgolia
                                        pacienteSelecionado={this.state.paciente}
                                        icon="fas fa-user"
                                        change={event => {
                                            if (event && event.value) {
                                                this.setState({
                                                    paciente: event
                                                })
                                            }
                                        }}
                                        styles={dropDownStyles}
                                    />
                                    <br />
                                    <SelectIcon
                                        placeholder="Selecione um grupo"
                                        icon="fas fa-procedures"
                                        value={this.state.grupoSelect}
                                        style={{ width: '100%', marginBottom: "10px" }}
                                        change={(vl) => { this.changeGrupo(vl.target.value) }}
                                        data={
                                            this.state.gruposProcedimentos ?
                                                this.state.gruposProcedimentos.map(it => { return { id: it.id, descricao: it.nome } }) : []
                                        }
                                    />

                                    <SelectIcon
                                        placeholder="Selecione o sub grupo"
                                        icon="fas fa-procedures"
                                        value={this.state.subSelect}
                                        style={{ width: '100%', marginBottom: "10px" }}
                                        change={(vl) => { this.changeSubGrupo(vl.target.value) }}
                                        disabled={!this.state.subProcedimentos}
                                        data={
                                            this.state.subProcedimentos ?
                                                this.state.subProcedimentos.map(it => { return { id: it.id, descricao: it.nome } }) : []
                                        }
                                    />

                                    <SelectIcon
                                        placeholder="Selecione a forma organização"
                                        icon="fas fa-procedures"
                                        value={this.state.formaOrganizacaoSelect}
                                        style={{ width: '100%', marginBottom: "10px" }}
                                        change={(vl) => { this.changeFormaOrganizacao(vl.target.value) }}
                                        disabled={!this.state.formaOrganizacao}
                                        data={
                                            this.state.formaOrganizacao ?
                                                this.state.formaOrganizacao.map(it => { return { id: it.id, descricao: it.nome } }) : []
                                        }
                                    />


                                    {/* <SelectIcon
                                        placeholder="Selecione o procedimento"
                                        icon="fas fa-procedures"
                                        value={this.state.procedimento}
                                        style={{ width: '100%' }}
                                        change={(vl) => { this.setState({ procedimento: vl.target.value }) }}
                                        disabled={!this.state.procedimentosList}
                                        data={
                                            this.state.procedimentosList ?
                                                this.state.procedimentosList.map(it => { return { id: it.id, descricao: it.nome } }) : []
                                        }
                                    /> */}

                                    <div className="gb-cont-select" style={{ width: "100%" }}>
                                        <div className="gb-input-icon">
                                            <i className='fas fa-procedures' />
                                        </div>
                                        <Select
                                            value={this.state.procedimento}
                                            onInputChange={e => this.filtrarProcedimento(e)}
                                            placeholder="Busque o procedimento"
                                            options={this.state.procedimentosListShow}
                                            isClearable
                                            isDisabled={!this.state.procedimentosListShow}
                                            styles={dropDownStyles}
                                            onChange={v => {
                                                this.setState({
                                                    procedimento: v
                                                })
                                            }} />
                                    </div>
                                    <br />
                                    <label>Anexar guia de solicitação do procedimento</label>
                                    <InputFileIcon
                                        icon={IconFile}
                                        placeholder="Arquivo"
                                        type="file"
                                        accept=".pdf, image/*"
                                        onChange={this.onChangeArquivo}
                                        width='100%'
                                        name='arquivo'
                                        urlToDownload={this.state.arquivo}
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.foraMunicipio}
                                                onChange={(ev) => { this.setState({ foraMunicipio: ev.target.checked }) }}
                                            />
                                        }
                                        label='Fora do município'
                                    />

                                    <button onClick={() => this._setCadastro()} className="btn gb-button to-form full mt-3">
                                        {this.props.item ? 'Editar' : "Adicionar"} Paciente

                                    </button>
                                </div>
                            </div>

                        </div>
                    )}
                </React.Fragment>
            );
        } else {
            return (<div className="alert alert-danger text-center">VOCÊ NÃO TEM PERMISSÃO DE ACESSO NESTA PÁGINA</div>)
        }
    }
}
